const isAnObject = (candidate) => candidate !== null &&
    candidate !== undefined &&
    typeof candidate === "object" &&
    Array.isArray(candidate) === false;
/**
 * This will flatten nested query params,
 * so that nested parameters are converted to top-level key-value pairs
 * This means that in the following example:
 * {
 *   ...
 *   'created_at': {
 *    'gte': '2021-03-02T16:47:25.162Z'
 *   }
 *   ...
 * }
 * the 'created_at' key would be replaced with:
 * {
 *  ...
 *  'created_at[gte]': 2021-03-02T16:47:25.162Z
 *  ...
 * }
 *
 * 'as keyof Q' had to be used multiple times in order
 * to satisfy typescript. And String(nestedKey) is needed
 * because nestedKey is a Symbol which needs to be
 * explicitly converted into a string.
 */
export const flattenedQueryParams = (queryParams) => {
    const isParamAnObject = isAnObject(queryParams);
    if (isParamAnObject) {
        const queryParamsObject = queryParams;
        return Object.entries(queryParamsObject).reduce((fold, [k, v]) => {
            const value = v;
            // A new top-level key-value pair is needed for each nested key-value pair
            if (isAnObject(value)) {
                const nestedObject = value;
                const newKeyValuePairs = nestedObject
                    ? Object.entries(nestedObject).map(([nestedKey, nestedValue]) => [
                        `${k}[${String(nestedKey)}]`,
                        nestedValue,
                    ])
                    : [];
                return {
                    ...fold,
                    ...Object.fromEntries(newKeyValuePairs),
                };
            }
            // The value isn't an object so leave it in the queryParams unchanged
            return {
                ...fold,
                [k]: queryParamsObject[k],
            };
        }, {});
    }
    return {};
};
export const endpointParamsExact = (endpointParams) => Object.keys(endpointParams).reduce((fold, k) => {
    if (endpointParams[k] == null) {
        return fold;
    }
    return {
        ...fold,
        [k]: endpointParams[k],
    };
}, {});
export const NOOP = {};
